import { render, staticRenderFns } from "./NotifBell.vue?vue&type=template&id=184c7788&scoped=true"
import script from "./NotifBell.vue?vue&type=script&lang=js"
export * from "./NotifBell.vue?vue&type=script&lang=js"
import style0 from "./NotifBell.vue?vue&type=style&index=0&id=184c7788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184c7788",
  null
  
)

export default component.exports